var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgViewIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 26,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 30,
  height: 26,
  fill: "#DBDBDB",
  rx: 2
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "#000",
  strokeOpacity: 0.7
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.77 16.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.958 11.934c.388.472.582.707.582 1.066s-.194.594-.582 1.066C21.538 15.79 18.406 19 14.77 19s-6.768-3.21-8.188-4.934C6.194 13.594 6 13.359 6 13s.194-.594.582-1.066C8.002 10.21 11.134 7 14.77 7s6.768 3.21 8.188 4.934Z"
}))));
export { SvgViewIcon as ReactComponent };
export default __webpack_public_path__ + "3edcdca01badb97ef64ea7739315b910.svg";